import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

const COINS = [
  { slug: "bitcoin",      symbol: "BTCUSDT",   ticker: "BTC",   name: "Bitcoin",       logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png" },
  { slug: "ethereum",     symbol: "ETHUSDT",   ticker: "ETH",   name: "Ethereum",      logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png" },
  { slug: "bnb",          symbol: "BNBUSDT",   ticker: "BNB",   name: "BNB",           logo: "https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png" },
  { slug: "xrp",          symbol: "XRPUSDT",   ticker: "XRP",   name: "XRP",           logo: "https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png" },
  { slug: "solana",       symbol: "SOLUSDT",   ticker: "SOL",   name: "Solana",        logo: "https://assets.coingecko.com/coins/images/4128/small/solana.png" },
  { slug: "cardano",      symbol: "ADAUSDT",   ticker: "ADA",   name: "Cardano",       logo: "https://assets.coingecko.com/coins/images/975/small/cardano.png" },
  { slug: "dogecoin",     symbol: "DOGEUSDT",  ticker: "DOGE",  name: "Dogecoin",      logo: "https://assets.coingecko.com/coins/images/5/small/dogecoin.png" },
  { slug: "tron",         symbol: "TRXUSDT",   ticker: "TRX",   name: "TRON",          logo: "https://assets.coingecko.com/coins/images/1094/small/tron-logo.png" },
  { slug: "avalanche",    symbol: "AVAXUSDT",  ticker: "AVAX",  name: "Avalanche",     logo: "https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png" },
  { slug: "polkadot",     symbol: "DOTUSDT",   ticker: "DOT",   name: "Polkadot",      logo: "https://assets.coingecko.com/coins/images/12171/small/polkadot.png" },
  { slug: "chainlink",    symbol: "LINKUSDT",  ticker: "LINK",  name: "Chainlink",     logo: "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png" },
  { slug: "litecoin",     symbol: "LTCUSDT",   ticker: "LTC",   name: "Litecoin",      logo: "https://assets.coingecko.com/coins/images/2/small/litecoin.png" },
  { slug: "polygon",      symbol: "POLUSDT",   ticker: "POL",   name: "Polygon",       logo: "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png" },
  { slug: "uniswap",      symbol: "UNIUSDT",   ticker: "UNI",   name: "Uniswap",       logo: "https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png" },
  { slug: "near",         symbol: "NEARUSDT",  ticker: "NEAR",  name: "NEAR Protocol", logo: "https://assets.coingecko.com/coins/images/10365/small/near.jpg" },
  { slug: "atom",         symbol: "ATOMUSDT",  ticker: "ATOM",  name: "Cosmos",        logo: "https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png" },
  { slug: "arbitrum",     symbol: "ARBUSDT",   ticker: "ARB",   name: "Arbitrum",      logo: "https://assets.coingecko.com/coins/images/16547/small/photo_2023-03-29_21.47.00.jpeg" },
  { slug: "optimism",     symbol: "OPUSDT",    ticker: "OP",    name: "Optimism",      logo: "https://assets.coingecko.com/coins/images/25244/small/Optimism.png" },
  { slug: "injective",    symbol: "INJUSDT",   ticker: "INJ",   name: "Injective",     logo: "https://assets.coingecko.com/coins/images/12882/small/Secondary_Symbol.png" },
  { slug: "sui",          symbol: "SUIUSDT",   ticker: "SUI",   name: "Sui",           logo: "https://assets.coingecko.com/coins/images/26375/small/sui_asset.jpeg" },
  { slug: "aptos",        symbol: "APTUSDT",   ticker: "APT",   name: "Aptos",         logo: "https://assets.coingecko.com/coins/images/26455/small/aptos_round.png" },
  { slug: "filecoin",     symbol: "FILUSDT",   ticker: "FIL",   name: "Filecoin",      logo: "https://assets.coingecko.com/coins/images/12817/small/filecoin.png" },
  { slug: "stellar",      symbol: "XLMUSDT",   ticker: "XLM",   name: "Stellar",       logo: "https://assets.coingecko.com/coins/images/100/small/Stellar_symbol_black_RGB.png" },
  { slug: "vechain",      symbol: "VETUSDT",   ticker: "VET",   name: "VeChain",       logo: "https://assets.coingecko.com/coins/images/1167/small/VET_Token_Icon.png" },
  { slug: "algorand",     symbol: "ALGOUSDT",  ticker: "ALGO",  name: "Algorand",      logo: "https://assets.coingecko.com/coins/images/4380/small/download.png" },
  { slug: "sandbox",      symbol: "SANDUSDT",  ticker: "SAND",  name: "The Sandbox",   logo: "https://assets.coingecko.com/coins/images/12129/small/sandbox_logo.jpg" },
  { slug: "mana",         symbol: "MANAUSDT",  ticker: "MANA",  name: "Decentraland",  logo: "https://assets.coingecko.com/coins/images/878/small/decentraland-mana.png" },
  { slug: "aave",         symbol: "AAVEUSDT",  ticker: "AAVE",  name: "Aave",          logo: "https://assets.coingecko.com/coins/images/12645/small/AAVE.png" },
  { slug: "render",       symbol: "RENDERUSDT",ticker: "RENDER",name: "Render",        logo: "https://assets.coingecko.com/coins/images/11636/small/rndr.png" },
  { slug: "pepe",         symbol: "PEPEUSDT",  ticker: "PEPE",  name: "Pepe",          logo: "https://assets.coingecko.com/coins/images/29850/small/pepe-token.jpeg" },
];

export default function CoinsIndex() {
  const [prices, setPrices] = useState({});

  useEffect(() => {
    const streams = COINS.map((c) => c.symbol.toLowerCase() + "@ticker").join("/");
    const ws = new WebSocket("wss://stream.binance.com:9443/stream?streams=" + streams);
    ws.onmessage = (e) => {
      const data = JSON.parse(e.data);
      const ticker = data?.data;
      if (!ticker) return;
      setPrices((prev) => ({
        ...prev,
        [ticker.s]: {
          price: parseFloat(ticker.c) || 0,
          change: parseFloat(ticker.P) || 0,
        },
      }));
    };
    return () => ws.close();
  }, []);

  return (
    <div className="pt-16 pb-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-8 mt-6">
          <span className="font-mono text-xs text-yellow-400 uppercase tracking-[0.3em]">/coins</span>
          <h1 className="font-display font-bold text-4xl md:text-5xl text-white tracking-tighter mt-2">
            Crypto Prices
          </h1>
          <p className="text-zinc-400 mt-2">Live prices powered by Binance. Click any coin for charts and details.</p>
        </div>

        <div className="bg-[#0a0a0b] border border-white/10 overflow-hidden">
          <div className="grid grid-cols-12 px-6 py-3 border-b border-white/10 text-xs font-mono uppercase tracking-widest text-zinc-500">
            <div className="col-span-1">#</div>
            <div className="col-span-5 md:col-span-4">Name</div>
            <div className="col-span-3 text-right">Price</div>
            <div className="col-span-3 text-right">24h</div>
            <div className="hidden md:block col-span-1 text-right">View</div>
          </div>

          {COINS.map((coin, index) => {
            const data = prices[coin.symbol];
            const price = data?.price || 0;
            const change = data?.change || 0;
            const isPositive = change >= 0;

            return (
              <Link
                key={coin.slug}
                to={"/coins/" + coin.slug}
                className="grid grid-cols-12 px-6 py-4 border-b border-white/5 hover:bg-white/5 transition items-center group"
              >
                <div className="col-span-1 font-mono text-sm text-zinc-500">{index + 1}</div>
                <div className="col-span-5 md:col-span-4 flex items-center gap-3">
                  <img src={coin.logo} alt={coin.name} className="w-7 h-7 md:w-8 md:h-8" onError={(e) => (e.target.style.display = "none")} />
                  <div>
                    <div className="font-display font-bold text-white group-hover:text-yellow-400 transition text-sm md:text-base">{coin.name}</div>
                    <div className="text-xs font-mono text-zinc-500">{coin.ticker}</div>
                  </div>
                </div>
                <div className="col-span-3 text-right font-display font-bold text-white text-sm md:text-base">
                  {price > 0
                    ? (price < 1 ? "$" + price.toFixed(6) : "$" + price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                    : "—"}
                </div>
                <div className={"col-span-3 text-right flex items-center justify-end gap-1 font-mono text-xs md:text-sm font-bold " + (isPositive ? "text-green-400" : "text-red-400")}>
                  {isPositive ? <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4" /> : <ArrowDownRight className="w-3 h-3 md:w-4 md:h-4" />}
                  {Math.abs(change).toFixed(2) + "%"}
                </div>
                <div className="hidden md:flex col-span-1 justify-end">
                  <span className="text-xs font-mono text-zinc-500 group-hover:text-yellow-400 transition">View →</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}